/**
 * Frontend URL config (CRA: define in .env / .env.development with REACT_APP_ prefix).
 * REACT_APP_BACKEND_URL — API origin only, no /api suffix (e.g. https://api.example.com)
 * REACT_APP_API_URL — optional override for REST base including /api
 * REACT_APP_WS_URL — optional Socket.IO origin (defaults to backend origin)
 */

function trimSlash(s) {
    return String(s || '').replace(/\/+$/, '');
}

let warnedMissingBackend;

export function getBackendUrl() {
    const fromApi = String(process.env.REACT_APP_API_URL || '').trim();
    if (fromApi) {
        const stripped = fromApi.replace(/\/api\/?$/i, '');
        if (stripped) return trimSlash(stripped);
    }
    const u = trimSlash(process.env.REACT_APP_BACKEND_URL || '');
    if (!u && process.env.NODE_ENV === 'development' && !warnedMissingBackend) {
        warnedMissingBackend = true;
        // eslint-disable-next-line no-console
        console.warn(
            '[config] Set REACT_APP_BACKEND_URL (and optionally REACT_APP_API_URL, REACT_APP_WS_URL) in frontend/.env.development'
        );
    }
    return u;
}

/** Base path for REST calls (…/api). */
export function getApiBaseUrl() {
    const explicit = trimSlash(process.env.REACT_APP_API_URL || '');
    if (explicit) return explicit;
    const base = getBackendUrl();
    return base ? `${base}/api` : '';
}

/** Origin for Socket.IO client (no path). */
export function getSocketUrl() {
    const w = trimSlash(process.env.REACT_APP_WS_URL || '');
    if (w) return w;
    return getBackendUrl();
}
